import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next';

import React, { Component } from 'react'

import { throttle, isMobile } from "../utilities/FrontFunctions/AoxGlobalFrontFunctions"
import { getApiDatas, postApiDatas, getStorageItem, isNotEmpty } from "../utilities/FrontFunctions/AoxFrontFunctions"
import { trackGA4Event } from '../utilities/FrontFunctions/AoxTrackingFunctions'
import ModalFormationsFav from "./inc/Modal/ModalFormationsFav"
import SectionHeroFormationCarousel from './inc/SectionHeroFormationCarousel'
import ObjListPushsThematiqueComptoirDermato from './inc/ObjListPushsThematiqueComptoirDermato'
import ObjTabsComptoirDermatoFormation from './inc/ObjTabsComptoirDermatoFormation'
import ObjDerniersAjoutsAside from './inc/ObjDerniersAjoutsAside'
import ObjExpertisePointsAside from './inc/ObjExpertisePointsAside'
import ObjFavoriteFormationAside from './inc/ObjFavoriteFormationAside'

import '../assets/css/0010_sections/0450_section_home_carrousel_tabs_formation.css'
import '../assets/css/0020_objects/0860_obj_title_page_comptoir_dermato.css'

class PageSegment extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isMobile: isMobile(),
		}
		this.handleWindowResizeMainHeader = this.handleWindowResizeMainHeader.bind(this)
		this.throttleWindowResizeMainHeader = throttle(this.handleWindowResizeMainHeader, 200)
		this.handleButtonFav = this.handleButtonFav.bind(this)
	}
	handleWindowResizeMainHeader() {
		this.setState({
			isMobile: isMobile()
		})
	}

    fetchData = () => {
        const { scDatas } = this.props.fields.data;
        getApiDatas(`/apiaox/Call/PageSegment?sSegmentId=${scDatas.id}&sBrandCode=${scDatas.ListBrand[0]?.codeAbbrege.value}`).then((apiDatas) => { 
            this.setState({ apiDatas:apiDatas })
            window.scrollTo(0,0);
        })
    };
    componentDidMount() {
        this.fetchData();
    }
    componentDidUpdate(prevProps) {
        // contrôle que sur le SegmentId; dans les ScDatas, SegmentId => BrandCode, donc si le BrandCode a changé, le SegmentId a changé
        if (this.props.fields.data?.scDatas?.id !== prevProps.fields.data?.scDatas?.id) {
            this.fetchData();
        }
    }

    handleButtonFav(id) {
        //pushs possibles sur les 3 tabs continuer, favoris, plus vues
        var datasTraining = this.state.apiDatas.TrainingsInProgress.find(t => t.Training_ItemTraining_Id === id);
        if(!datasTraining){ datasTraining = this.state.apiDatas.TrainingsFavorite.find(t => t.Training_ItemTraining_Id === id); }
        if(!datasTraining){ datasTraining = this.state.apiDatas.TrainingsMostView.find(t => t.Training_ItemTraining_Id === id); }
        if(datasTraining){
            if(!datasTraining.Training_IsFavorite){
                //ajouter favori
                document.body.classList.add('is-loading')
                trackGA4Event(window.trackDatas, "training_add_favorite", "training", "training add favorite", "star icon");
                postApiDatas(`/apiaox/Call/AddTrainingFavorite?sIdTraining=${id}`, {})
                .then((res) => {
                    document.body.classList.remove('is-loading')
                    if (!res.IsValid) { alert(res.Message) }
                    else {
                        let newDatas = this.state.apiDatas;

                        //switcher le statut sur les 2 listes continuer & plus vues
                        newDatas.TrainingsInProgress.forEach(t => {if(t.Training_ItemTraining_Id === id){t.Training_IsFavorite = true}});
                        newDatas.TrainingsMostView.forEach(t => {if(t.Training_ItemTraining_Id === id){t.Training_IsFavorite = true}});

                        //ajouter à la liste des favoris
                        //(voir plus bas) l'item n'a pas été supprimé avant => filter() pour le supprimer ici avant de l'ajouter
                        newDatas.TrainingsFavorite = this.state.apiDatas.TrainingsFavorite.filter(t => t.Training_ItemTraining_Id !== id)
                        datasTraining.Training_IsFavorite = true;
                        newDatas.TrainingsFavorite.push(datasTraining);

                        this.setState({ apiDatas: newDatas })
                        
                        if(!getStorageItem('dontShowAgainModalMAJFormationsFav')){
                            this.ModalFormationsFav.openModal();
                        }
                    }
                });
            } else {
                //supprimer favori
                document.body.classList.add('is-loading')
                postApiDatas(`/apiaox/Call/RemoveTrainingFavorite?sIdTraining=${id}`, {})
                .then((res) => {
                    document.body.classList.remove('is-loading')
                    if (!res.IsValid) { alert(res.Message) }
                    else {
                        let newDatas = this.state.apiDatas;

                        //switcher le statut sur les 2 listes
                        newDatas.TrainingsInProgress.forEach(t => {if(t.Training_ItemTraining_Id === id){t.Training_IsFavorite = false}});
                        newDatas.TrainingsMostView.forEach(t => {if(t.Training_ItemTraining_Id === id){t.Training_IsFavorite = false}});
                        //supprimer à la liste des favoris
                        //à cause d'un pb d'actualisation, pas de suppression de pushs dynamique au slicker => juste switch de son statut
                        newDatas.TrainingsFavorite.forEach(t => {if(t.Training_ItemTraining_Id === id){t.Training_IsFavorite = false}});

                        this.setState({ apiDatas: newDatas })
                    }
                });
            }
        }
    }

	render() {
        const { scDatas } = this.props.fields.data;
        const { apiDatas } = this.state;

		return (<>{ scDatas && apiDatas && <>

            {isNotEmpty(scDatas.ListFolderBanners[0]?.ListBanners) && <>
                <SectionHeroFormationCarousel dataBanners={scDatas.ListFolderBanners[0].ListBanners}/>
            </>}

			{apiDatas.UserBrandExpertise && this.state.isMobile &&
				<ObjExpertisePointsAside datasExpertise={apiDatas.UserBrandExpertise}/>	
			}

			<section className="obj_section obj_title_page_comptoir_dermato">
				<div className="ctn_title">
					<h2 className="t_title">{scDatas.pageTitle.jss.value}</h2>
				</div>
			</section>

			<section className="obj_section section_aside_content">
				<div className="ctn_section">
					<div className="ctn_columns">
						<div className="ctn_content">
                            {scDatas.ListThemeFolder[0]?.ListTheme && 
                                <ObjListPushsThematiqueComptoirDermato datasThemes={scDatas.ListThemeFolder[0].ListTheme}/>
                            }

							<ObjTabsComptoirDermatoFormation datasTrainings={apiDatas} handleButtonFav={this.handleButtonFav}/>
						</div>

						<div className="ctn_aside">
							{apiDatas.UserBrandExpertise && !this.state.isMobile && 
                                <ObjExpertisePointsAside datasExpertise={apiDatas.UserBrandExpertise}/>
                            }

							{apiDatas.TrainingsMostRecent && (apiDatas.TrainingsMostRecent.length > 0) && 
                                <ObjDerniersAjoutsAside datasTrainings={apiDatas.TrainingsMostRecent}/>
                            }

							{apiDatas.TrainingsFavorite && (apiDatas.TrainingsFavorite.length > 0) && 
                                <ObjFavoriteFormationAside datasTrainings={apiDatas.TrainingsFavorite}/>
                            }
						</div>
					</div>
				</div>
			</section>

            <ModalFormationsFav 
                onRef={ref => (this.ModalFormationsFav = ref)} 
                modalTitle=""
                modalText="Vous venez d'ajouter cette formation à votre liste de favoris"
                modalCtaText="Retrouver mes favoris"
            />
        </>}</>)
    }
}

export default withTranslation()(withSitecoreContext()(PageSegment));